import { useTranslation } from 'react-i18next';

import { Wrapper, Text } from './EmptyInfo.styles';

export const EmptyInfo = () => {
  const { t } = useTranslation('AcademyDetailTranslations');
  return (
    <Wrapper>
      <Text>{t('NO_INFORMATION_AVAILABLE')}</Text>
    </Wrapper>
  );
};
